import {
  AUTH_TOKEN_STORAGE_KEY,
  AUTH_USER_STORAGE_KEY,
  INVENTORY_DRAFT_STORAGE_PREFIX,
  SHOP_ID_STORAGE_KEY,
  SHOP_INFO_STORAGE_KEY,
} from '@/config/app';

const STORAGE_KEY_MAPPINGS: Array<[string, string]> = [
  ['suite241_stock_token', AUTH_TOKEN_STORAGE_KEY],
  ['suite241_stock_user', AUTH_USER_STORAGE_KEY],
  ['suite241_stock_current_shop_id', SHOP_ID_STORAGE_KEY],
  ['suite241_stock_current_shop_info', SHOP_INFO_STORAGE_KEY],
  ['suite241_thermal_printer_settings', 'suite241_gestion_commerciale_thermal_printer_settings'],
];

const STORAGE_PREFIX_MAPPINGS: Array<[string, string]> = [
  ['suite241_stock_inventory_', INVENTORY_DRAFT_STORAGE_PREFIX],
  ['suite241_stock_user_settings_', 'suite241_gestion_commerciale_user_settings_'],
  ['suite241-stock:purchase-lines:', 'suite241-gestion-commerciale:purchase-lines:'],
];

const hasLocalStorage = (): boolean =>
  typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';

const migrateExactStorageKeys = (): void => {
  if (!hasLocalStorage()) return;

  STORAGE_KEY_MAPPINGS.forEach(([oldKey, newKey]) => {
    const oldValue = window.localStorage.getItem(oldKey);
    if (oldValue === null) return;

    if (window.localStorage.getItem(newKey) === null) {
      window.localStorage.setItem(newKey, oldValue);
    }

    if (oldKey !== newKey) {
      window.localStorage.removeItem(oldKey);
    }
  });
};

const migratePrefixedStorageKeys = (): void => {
  if (!hasLocalStorage()) return;

  const keys = Array.from({ length: window.localStorage.length }, (_, index) => window.localStorage.key(index))
    .filter((key): key is string => Boolean(key));

  keys.forEach((key) => {
    const mapping = STORAGE_PREFIX_MAPPINGS.find(([oldPrefix]) => key.startsWith(oldPrefix));
    if (!mapping) return;

    const [oldPrefix, newPrefix] = mapping;
    const oldValue = window.localStorage.getItem(key);
    if (oldValue === null) return;

    const newKey = `${newPrefix}${key.slice(oldPrefix.length)}`;
    if (window.localStorage.getItem(newKey) === null) {
      window.localStorage.setItem(newKey, oldValue);
    }

    if (oldPrefix !== newPrefix) {
      window.localStorage.removeItem(key);
    }
  });
};

export const migrateSuite241GestionCommercialeStorage = (): void => {
  migrateExactStorageKeys();
  migratePrefixedStorageKeys();
};
